import * as React from 'react'
import ReactPlayer from 'react-player'
import Youtube from 'react-youtube'
import { Image } from 'components'
import SoundPlayer from 'components/ResourcePlayer/SoundPlayer'

type Props = {
  resource: { uri?: string; videoId?: string }
  resourceType?: string
  square?: boolean
}

export default function ResourcePlayer({
  resource,
  resourceType,
  square,
}: Props) {
  if (!resource) return null

  if (resourceType === 'image')
    return <Image square={square} src={resource.uri} />

  if (resourceType === 'video') {
    if (resource.videoId)
      return (
        <Youtube
          opts={{
            width: '100%',
          }}
          videoId={resource.videoId}
        />
      )

    return (
      <div style={{ padding: '30px 0', textAlign: 'center' }}>
        <ReactPlayer
          width="100%"
          height="auto"
          url={resource.uri}
          controls
          config={{
            file: {
              attributes: {
                controlsList: 'nodownload',
                onContextMenu: e => e.preventDefault(),
              },
            },
          }}
        />
      </div>
    )
  }

  if (resourceType === 'audio' || resourceType === 'sound')
    return <SoundPlayer uri={resource.uri} />

  return null
}
